let Vm = null

// 获取URL query 参数对象
export function getUrlQueryMap() {
  if (Vm && Vm.$route.query.length) {
    console.log(Vm.$route.query)
    return Vm.$route.query
  }
  let arr = {}
  const str = window.location.search.substring(1)
  if (str) {
    for (let item of str.split('&')) {
      let [key, value] = item.split('=')
      arr[key] = value
    }
  }
  return arr
}

// 获取URL query
export function getUrlQueryVar(key, value = null) {
  let query = getUrlQueryMap()
  if (typeof query[key] !== 'undefined') {
    return query[key]
  } else {
    return value
  }
}

// 获取当前秒时间戳
export function getNowTimestamp() {
  return Math.floor(new Date().valueOf() / 1000)
}

// 获取随机字符串
export function createRandomStr(len = 16) {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  while (len > 0) {
    len--
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

// 设置vm 实例
export function setVm(vm) {
  Vm = vm
}
// 获取 vm 实例
export function getVm() {
  return Vm
}

export function jumpOutUrl(url) {
  if (process.env.NODE_ENV == 'production') {
    window.location.href = url
  } else {
    console.warn('----模拟跳转开始----')
    console.warn(url)
    console.warn('----模拟跳转结束----')
  }
}
